@if (isActive) {
  <topo-modal
    id="template-edit-modal"
    [isActive]="isActive"
    [backgroundCanClose]="true"
    [isCard]="true"
    [headerIsFullWidth]="true"
    [noHeaderBorder]="true"
    [removeHeaderBottomPadding]="true"
    [hideFooter]="true"
    [noBodyPadding]="true"
    [rawWidth]="'99vw'"
    [rawHeight]="'99vh'"
    (close)="close()">
    <div class="modal-header header">
      <div
        fxLayout="row"
        fxLayoutAlign="space-between center">
        <div
          class="header"
          fxLayout="row"
          fxLayoutAlign="start center">
          <img src="assets/images/template.svg" />
          <div class="title">{{ template?.name }}</div>
        </div>
        <div
          class="button-container ml-2 pl-1 pr-1"
          fxLayout="row"
          fxLayoutAlign="center center">
          <div class="mr-3">
            <topo-header-bar-tab-button
              theme="white"
              [isSelected]="mainTabIndex === 0"
              [isSmall]="true"
              [label]="'COMMUNICATIONS.TAB-NOTIFICATION-SETTINGS' | translate"
              (click)="onSettingsTabSelected()"
              icon="icon-bullhorn"></topo-header-bar-tab-button>
          </div>
          <div class="mr-3">
            <topo-header-bar-tab-button
              theme="white"
              [isSelected]="mainTabIndex === 1"
              [isSmall]="true"
              [label]="'COMMUNICATIONS.TAB-MESSAGE-TEMPLATES' | translate"
              (click)="onTemplatesTabSelected()"
              icon="icon-template"></topo-header-bar-tab-button>
          </div>
        </div>
        <div
          fxLayout="row"
          fxLayoutAlign="end center"
          class="mr-3 save-buttons">
          <div class="ml-3">
            <button
              class="header-button save-button"
              [ngClass]="{ 'disabled': !isDirty || (hasSMSMessage && (isDesignerOverLimit() || isSmsOverLimit)) }"
              [disabled]="!isDirty || (hasSMSMessage && (isDesignerOverLimit() || isSmsOverLimit))"
              [ngStyle]="{ 'visibility': isDirty ? 'visible' : 'hidden' }"
              (click)="onSaveAndClose()">
              <span>{{ 'MANAGEMENT.BUTTONS.SAVE-CLOSE' | translate }}</span>
            </button>
          </div>
          <div
            [ngStyle]="{ 'visibility': !isDirty || (hasSMSMessage && (isDesignerOverLimit() || isSmsOverLimit)) ? 'hidden' : 'visible' }"
            class="more-button"
            (click)="showSaveMenu($event)">
            <i class="icon icon-caret_down"></i>
            <topo-action-menu
              #actions
              icon=""
              class="ml-2">
              <topo-action
                label="{{ 'MAP.SAVE' | translate }}"
                icon="icon-cloud_upload"
                (actionClick)="onSave()"></topo-action>
            </topo-action-menu>
          </div>
          <div
            class="dialog-close ml-2 header-close"
            (click)="close()">
            <i class="icon icon-close-X"></i>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-body">
      <div
        fxLayout="row"
        fxLayoutAlign="start top"
        style="height: 100%">
        <!-- Left Drawer -->
        <div
          class="drawer-container"
          [class.open]="isDrawerOpen">
          <topo-comms-left-drawer
            height="100%"
            [isOpen]="isDrawerOpen"
            [showOpenCloseHandle]="false"
            (visibilityChanged)="drawerOpenClose($event)">
            <div class="tabs-container">
              @if (mainTabIndex === 0) {
                <div>
                  <topo-tabs
                    [selectedTabIndex]="selectedTabIndex"
                    [tabs]="settingsTabs"
                    (selectedTabIndexChanged)="tabChanged($event)"></topo-tabs>
                </div>
                <!-- Overview -->
                @if (selectedTabIndex === 0) {
                  <div class="template-properties scrollbar-y">
                    <div class="body">
                      @if (template?.lastEditedById) {
                        <div class="field">
                          <label>{{ 'COMMUNICATIONS.COLUMNS.CREATED-ON' | translate }}</label>
                          {{ createdOn }}
                        </div>
                      }
                      @if (template?.lastEditedById) {
                        <div class="field">
                          <label>{{ 'COMMUNICATIONS.COLUMNS.UPDATED-ON' | translate }}</label>
                          {{ updatedOn }}
                        </div>
                      }
                      @if (template?.lastEditedById) {
                        <div class="field">
                          <label>{{ 'COMMUNICATIONS.COLUMNS.UPDATED-BY' | translate }}</label>
                          <topo-avatar
                            [name]="template.lastEditedByName"
                            [size]="24"
                            [showName]="true"></topo-avatar>
                        </div>
                      }
                    </div>
                  </div>
                }
              }
              @if (mainTabIndex === 1) {
                <!-- Setting Area -->
                @if (currentControlToEdit) {
                  <div>
                    <div class="settings-container">
                      <div
                        class="header"
                        fxLayout="row"
                        fxLayoutAlign="start center">
                        <button
                          class="button is-small is-ghost"
                          (click)="hideSettings()">
                          <i class="icon icon-arrow2_left"></i>
                        </button>
                        <div class="title">{{ 'COMMUNICATIONS.ELEMENT-SETTINGS' | translate: { name: getSelectedSettingsName() } }}</div>
                      </div>
                      <div>
                        <div class="body">
                          <div
                            topo-template-design-element
                            #settingsElement
                            [editMode]="true"
                            [culture]="selectedCulture"
                            [orgLanguages]="languages"
                            [messageSettings]="template?.defaultMessageSettings"
                            [template]="selectedCommunicationTemplate"
                            (settingsChanged)="selectedControlChanged($event)"
                            [control]="currentControlToEdit ?? null"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                }
                @if (!currentControlToEdit) {
                  <!-- Design Elements -->
                  <div class="tools-container">
                    <div class="header">
                      <div class="title">{{ 'COMMUNICATIONS.DESIGNER-TOOLS' | translate }}</div>
                    </div>
                    @if (languages?.length > 0) {
                      <div class="field language-selection">
                        <label>{{ 'MANAGEMENT.ORGANIZATIONS.LANGUAGE' | translate }}</label>
                        <div class="select is-primary is-fullwidth is-medium">
                          <select
                            [(ngModel)]="selectedCulture"
                            (ngModelChange)="cultureChanged()">
                            @for (lang of languages; track lang) {
                              <option [ngValue]="lang">
                                {{ getLanguageDisplay(lang) }}
                              </option>
                            }
                          </select>
                        </div>
                      </div>
                    }
                    @if (selectedContentTabIndex > 0) {
                      <div>
                        <topo-template-design-elements-selection
                          [channelUId]="selectedCommunicationTemplate?.channelUId"
                          [disabledElements]="disabledElementTypes"></topo-template-design-elements-selection>
                      </div>
                    }
                  </div>
                }
              }
            </div>
          </topo-comms-left-drawer>
        </div>
        <!-- Main Content -->
        <div
          class="content-container"
          [ngClass]="{ 'drawer-open': isDrawerOpen }">
          @if (mainTabIndex === 0) {
            <div class="selected-tab-content-container">
              <div
                fxLayout="row"
                fxLayoutAlign="center top"
                class="notification-tabs">
                <topo-tabs
                  [selectedTabIndex]="selectedNotificationTabIndex"
                  [tabs]="notificationTabs"
                  (selectedTabIndexChanged)="notificationTabChanged($event)"></topo-tabs>
              </div>
              <div class="properties-container px-5">
                @if (selectedNotificationTabIndex === 0) {
                  <div>
                    <div
                      fxLayout="row"
                      fxLayoutAlign="center top">
                      <div class="properties">
                        <div class="field">
                          <label>{{ 'COMMUNICATIONS.COLUMNS.NAME' | translate }}</label>
                          <div>
                            <input
                              class="input is-small is-fullwidth"
                              type="text"
                              placeholder="{{ 'COMMUNICATIONS.COLUMNS.NAME' | translate }}"
                              (ngModelChange)="setChanged()"
                              [(ngModel)]="templateName" />
                          </div>
                        </div>
                        <div class="field">
                          <label>{{ 'COMMUNICATIONS.DESCRIPTION' | translate }}</label>
                          <div>
                            <textarea
                              class="input is-small is-fullwidth multiline-text"
                              type="text"
                              cols="6"
                              placeholder="{{ 'COMMUNICATIONS.DESCRIPTION' | translate }}"
                              (ngModelChange)="setChanged()"
                              [(ngModel)]="templateDesc"></textarea>
                          </div>
                        </div>
                        <div class="field">
                          <label>{{ 'COMMUNICATIONS.COLUMNS.TYPE' | translate }}</label>
                          <div>
                            <div class="radio-list">
                              @for (templateType of templateTypes; track templateType) {
                                <div>
                                  <label class="radio">
                                    <input
                                      type="radio"
                                      name="templateType"
                                      [checked]="selectedTemplateType === templateType"
                                      value="false"
                                      (change)="templateTypeSelected(templateType)" />
                                    {{ 'COMMUNICATIONS.NOTIFICATION-TYPE-' + templateType | translate }}
                                  </label>
                                </div>
                              }
                            </div>
                          </div>
                        </div>
                        @if (hasBusinessUnits) {
                          <div class="field">
                            <label>{{ 'COMMUNICATIONS.BUSINESS-UNITS' | translate }}</label>
                            <div
                              class="business-units"
                              [ngClass]="{ 'disabled': !(businessUnits?.length > 0) }">
                              <topo-business-unit-select
                                [multiSelectionMode]="true"
                                [selectedUIds]="selectedUnitUIds"
                                [businessUnits]="businessUnits"
                                location="right"
                                (selectedChanged)="onBusinessUnitsSelectionChanged($event)"></topo-business-unit-select>
                            </div>
                          </div>
                        }
                        <div class="field">
                          <label>{{ 'COMMUNICATIONS.NOTIFICATION-WORKFLOW-TEMPLATE' | translate }}</label>
                          <div class="select is-secondary is-medium">
                            <select
                              [(ngModel)]="selectedNotificationWorkflowTemplateUId"
                              (ngModelChange)="setChanged()">
                              @for (template of notificationWorkflowTemplates; track template.uId) {
                                <option [ngValue]="template.uId">
                                  {{ template.name }}
                                </option>
                              }
                            </select>
                          </div>
                        </div>
                        <div class="field">
                          <label>{{ 'COMMUNICATIONS.RECIPIENT-WORKFLOW-TEMPLATE' | translate }}</label>
                          <div class="select is-secondary is-medium">
                            <select
                              [(ngModel)]="selectedRecipientWorkflowTemplateUId"
                              (ngModelChange)="setChanged()">
                              @for (template of recipientWorkflowTemplates; track template.uId) {
                                <option [ngValue]="template.uId">
                                  {{ template.name }}
                                </option>
                              }
                            </select>
                          </div>
                        </div>
                        @if (templateGroups?.length > 0) {
                          <div class="field">
                            <label>{{ 'COMMUNICATIONS.COLUMNS.TEMPLATE-GROUP' | translate }}</label>
                            <div class="select is-secondary is-medium">
                              <select
                                [(ngModel)]="selectedTemplateGroupUId"
                                (ngModelChange)="setChanged()">
                                <option [ngValue]="null">{{ 'COMMUNICATIONS.SELECT-TEMPLATE-GROUP' | translate }}</option>
                                @for (templateGroup of templateGroups; track templateGroup.uId) {
                                  <option [ngValue]="templateGroup.uId">
                                    {{ templateGroup.name }}
                                  </option>
                                }
                              </select>
                            </div>
                          </div>
                        }
                        <div class="field">
                          <label>{{ 'COMMUNICATIONS.ALLOWED-OVERRIDES' | translate }}</label>
                          <div
                            fxLayout="row"
                            fxLayoutAlign="space-between center">
                            <label class="radio">
                              {{ 'COMMUNICATIONS.OVERRIDE-CHANNELS' | translate }}
                            </label>
                            <div>
                              <topo-switch
                                [(ngModel)]="canChangeChannels"
                                (click)="setChanged()"></topo-switch>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                }
                @if (selectedNotificationTabIndex === 1) {
                  <div>
                    <div
                      fxLayout="row"
                      fxLayoutAlign="center top">
                      <div class="properties">
                        <topo-template-channels-selection
                          [readonlyMode]="false"
                          [channelsCascadeSettings]="template?.channelsCascadeSettings"
                          [allowedChanges]="allAllowedChangesForChannels"
                          [responseRequired]="isSafetyCheckType()"
                          width="920"
                          (changed)="channelSelectionChanged($event)"></topo-template-channels-selection>
                      </div>
                    </div>
                  </div>
                }
                @if (selectedNotificationTabIndex === 2) {
                  <div>
                    <div
                      fxLayout="row"
                      fxLayoutAlign="center top">
                      <div class="properties recipients-container">
                        <topo-comms-recipients-selection
                          [includeUsers]="true"
                          [includeGroups]="false"
                          [includeDistro]="true"
                          [includeDatasets]="true"
                          (selectedRecipientsChanged)="selectedRecipientsChanged($event)"
                          [toRecipientSettings]="template?.recipientSettings"></topo-comms-recipients-selection>
                      </div>
                    </div>
                  </div>
                }
              </div>
            </div>
          }
          <!-- Designer -->
          @if (mainTabIndex == 1) {
            <div class="selected-tab-content-container">
              <div
                fxLayout="row"
                fxLayoutAlign="center top"
                class="content-tabs">
                <topo-tabs
                  [selectedTabIndex]="selectedContentTabIndex"
                  [tabs]="contentTabs"
                  [icons]="contentTabIcons"
                  [iscautionicons]="isSmsOverLimitReached$ | async"
                  (selectedTabIndexChanged)="contentTabChanged($event)"></topo-tabs>
              </div>
              @if (selectedContentTabIndex === 0) {
                <div class="template-message">
                  <div class="body">
                    @if (hasHTMLMessage) {
                      <div class="field">
                        <div
                          fxLayout="row"
                          fxLayoutAlign="space-between center">
                          <div class="title">
                            {{ 'COMMUNICATIONS.NOTIFICATION-MESSAGE' | translate }}
                          </div>
                          @if (hasSMSMessage) {
                            <div
                              fxLayout="row"
                              fxLayoutGap="8px"
                              fxLayoutAlign="start center"
                              class="mb-1">
                              <div class="separate-sms-check">{{ 'COMMUNICATIONS.USE-SEPARATE-SMS-MESSAGE' | translate }}</div>
                              <topo-switch
                                [checked]="!singleMessageMode"
                                (checkChanged)="setSingleMessageMode($event)"></topo-switch>
                            </div>
                          }
                        </div>
                        <div class="notification-message">
                          <quill-editor
                            [styles]="{ height: '150px' }"
                            [placeholder]="'COMMUNICATIONS.NOTIFICATION-MESSAGE' | translate"
                            [modules]="editorModules"
                            [(ngModel)]="selectedDefaultMessage"
                            (onContentChanged)="onEditorContentChanged($event)"
                            (onEditorCreated)="editorCreated($event)"></quill-editor>
                        </div>
                        @if (singleMessageMode) {
                          <div
                            class="sms-counter"
                            fxLayout="row"
                            fxLayoutAlign="end center">
                            {{ messageCharCount }}
                          </div>
                        }
                      </div>
                    }
                    @if (hasSMSMessage && (!singleMessageMode || !hasHTMLMessage)) {
                      <div class="field">
                        <div class="title flex-label">
                          {{ 'COMMUNICATIONS.SMS-NOTIFICATION-MESSAGE' | translate }}
                          <i
                            [matTooltip]="'COMMUNICATIONS.SMS-TOOLTIP-MESSAGE' | translate"
                            class="tooltip-icon-info icon icon-help"
                            matTooltipPosition="right"
                            [matTooltipShowDelay]="500"
                            [matTooltipHideDelay]="500000"></i>
                        </div>
                        <mat-form-field
                          appearance="outline"
                          class="full-width">
                          <textarea
                            matInput
                            cdkTextareaAutosize
                            #autosize="cdkTextareaAutosize"
                            cdkAutosizeMinRows="8"
                            cdkAutosizeMaxRows="8"
                            placeholder="{{ 'COMMUNICATIONS.SMS-NOTIFICATION-MESSAGE' | translate }}"
                            [(ngModel)]="selectedDefaultSmsMessage"
                            (ngModelChange)="smsNotificationMessageChanged($event)"
                            (keyup)="smsNotificationMessageUpdated($event)"
                            (keydown)="preventInputWhenLimitReached($event)"
                            [maxlength]="absoluteMaxLimit"></textarea>
                          <div class="character-count-container">
                            <div class="flex-between">
                              <!-- Character counter that changes color based on limit status -->
                              <span
                                class="character-count"
                                [ngClass]="{ 'warning': isApproachingLimit(), 'error': isOverLimit() }">
                                SMS: {{ getRemainingCharacters() }} characters {{ isOverLimit() ? 'over' : 'remaining' }}
                              </span>
                            </div>
                            <!-- Progress bar that visualizes character usage -->
                            <mat-progress-bar
                              [ngClass]="getProgressBarColor()"
                              [value]="getProgressValue()"></mat-progress-bar>
                          </div>
                        </mat-form-field>
                        <!-- Validation messages section -->
                        <div class="validation-messages">
                          <!-- Error message when over the limit -->
                          @if (isOverLimit()) {
                            <div class="error-message">SMS must be fewer than {{ singleSmsLimit + 1 }} characters</div>
                          }
                          <!-- Warning about multi-part SMS -->
                          @if (isApproachingLimit()) {
                            <div class="warning-message">
                              {{ 'COMMUNICATIONS.SMS-WARNING-MESSAGE' | translate }}
                            </div>
                          }
                        </div>
                      </div>
                    }
                    @if (isSafetyCheckType()) {
                      <div class="confirmation-section">
                        <div class="field">
                          <div class="title">{{ 'COMMUNICATIONS.CONFIRMATION-QUESTION' | translate }}</div>
                          <div
                            fxLayout="row"
                            fxLayoutAlign="start center">
                            <input
                              class="input is-small is-fullwidth question"
                              type="text"
                              placeholder="{{ 'COMMUNICATIONS.CONFIRMATION-QUESTION' | translate }}"
                              (ngModelChange)="confirmationTextChanged($event)"
                              [ngModel]="selectedConfirmationMessage" />
                          </div>
                        </div>
                        <div class="field">
                          <div class="title">{{ 'COMMUNICATIONS.CONFIRMATION-ANSWERS' | translate }}</div>
                          @for (confirmationButton of confirmationButtons; track confirmationButton.uId; let i = $index) {
                            <div>
                              <div
                                fxLayout="row"
                                fxLayoutAlign="start center"
                                class="mb-2">
                                <div class="answer-marker">
                                  <div class="counter">{{ i + 1 }}</div>
                                </div>
                                <input
                                  class="input is-small answer-input"
                                  type="text"
                                  (ngModelChange)="confirmationButtonChanged(i, $event)"
                                  [ngModel]="confirmationButton?.text" />
                                <div class="select is-primary is-medium ml-2 answer-action">
                                  <select
                                    [ngModel]="confirmationButton?.type"
                                    (ngModelChange)="confirmationButtonActionChanged(i, $event)">
                                    <option [value]="ConfirmationType.Positive">
                                      {{ 'COMMUNICATIONS.POSITIVE-ANSWER' | translate }}
                                    </option>
                                    <option [value]="ConfirmationType.Negative">
                                      {{ 'COMMUNICATIONS.NEGATIVE-ANSWER' | translate }}
                                    </option>
                                  </select>
                                </div>
                                <div
                                  class="action-delete"
                                  title="{{ 'COMMUNICATIONS.REMOVE-ANSWER' | translate }}"
                                  (click)="deleteConfirmationButtonClick(i)">
                                  <i class="icon icon-remove_outline"></i>
                                </div>
                              </div>
                            </div>
                          }
                          <div class="answer-counter">
                            <div class="answer-marker">
                              <div
                                class="counter clickable"
                                (click)="addConfirmationButtonClick()">
                                +
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              }
              @if (selectedContentTabIndex !== 0) {
                <div
                  (click)="onDesignerClicked($event)"
                  class="designer-container"
                  [ngClass]="{
                    'is-sms':
                      selectedCommunicationTemplate?.channelUId === ChannelUIds.TwilioChannelUId ||
                      selectedCommunicationTemplate?.channelUId === ChannelUIds.HorizonSmsChannelUId ||
                      selectedCommunicationTemplate?.channelUId === ChannelUIds.WhatsAppChannelUId
                  }"
                  id="designer-container">
                  @if (showEmailSubject) {
                    <div
                      fxLayout="row"
                      fxLayoutAlign="center top">
                      <div class="field email-subject">
                        <topo-dataset-field-template
                          title="{{ 'COMMUNICATIONS.EMAIL-SUBJECT' | translate }}"
                          instructions="{{ 'COMMUNICATIONS.EMAIL-SUBJECT-FIELDS' | translate }}"
                          [value]="emailSubject"
                          [multiLine]="false"
                          (changed)="emailSubjectChanged($event)"></topo-dataset-field-template>
                      </div>
                    </div>
                  }
                  @if (showPushTitle) {
                    <div
                      fxLayout="row"
                      fxLayoutAlign="center top">
                      <div class="field email-subject">
                        <topo-dataset-field-template
                          title="{{ 'COMMUNICATIONS.PUSH-TITLE' | translate }}"
                          instructions="{{ 'COMMUNICATIONS.PUSH-TITLE-FIELDS' | translate }}"
                          [value]="pushTitle"
                          [multiLine]="false"
                          (changed)="pushTitleChanged($event)"
                          [required]="showPushSummary"></topo-dataset-field-template>
                      </div>
                    </div>
                  }
                  @if (showPushSummary) {
                    <div
                      fxLayout="row"
                      fxLayoutAlign="center top">
                      <div class="field email-subject">
                        <topo-dataset-field-template
                          title="{{ 'COMMUNICATIONS.PUSH-SUMMARY' | translate }}"
                          instructions="{{ 'COMMUNICATIONS.PUSH-SUMMARY-FIELDS' | translate }}"
                          [value]="pushSummary"
                          [multiLine]="true"
                          (changed)="pushSummaryChanged($event)"
                          [required]="showPushSummary"></topo-dataset-field-template>
                      </div>
                    </div>
                  }
                  <div
                    fxLayout="row"
                    fxLayoutAlign="center top">
                    <div class="body">
                      <topo-comms-template-designer
                        #designer
                        width="800px"
                        [culture]="selectedCulture"
                        [previewMessageVisible]="true"
                        [editable]="true"
                        [editableControlTypes]="editableControlTypes"
                        [messageSettings]="template?.defaultMessageSettings"
                        [template]="selectedCommunicationTemplate"
                        (changed)="templateDesignChanged($event)"
                        (controlChanged)="templateDesignControlChanged($event)"
                        (controlSelected)="templateDesignControlSelected($event)"
                        (controlDeleted)="templateDesignControlDeleted($event)"
                        (controlEdited)="templateDesignControlEdited($event)"></topo-comms-template-designer>
                    </div>
                  </div>
                  @if (hasSMSMessage && isSmsTab) {
                    <div class="progress-designer">
                      <div class="progress-container">
                        <div class="character-count-container">
                          <div class="flex-between">
                            <span
                              class="character-count"
                              [ngClass]="{ 'warning': isDesignerApproachingLimit(), 'error': isDesignerOverLimit() }">
                              SMS: {{ getDesignerRemainingCharacters() }} characters {{ isDesignerOverLimit() ? 'over' : 'remaining' }}
                            </span>
                          </div>
                          <mat-progress-bar
                            [value]="getDesignerProgressValue()"
                            [ngClass]="getDesignerProgressColor()"></mat-progress-bar>
                        </div>
                        <div class="validation-messages">
                          <!-- Error message when over the limit -->
                          @if (isDesignerOverLimit()) {
                            <div class="error-message">SMS must be fewer than {{ singleSmsLimit + 1 }} characters</div>
                          }
                          <!-- Warning about multi-part SMS -->
                          @if (isDesignerApproachingLimit()) {
                            <div class="warning-message">
                              {{ 'COMMUNICATIONS.SMS-WARNING-MESSAGE' | translate }}
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                  }
                </div>
              }
            </div>
          }
        </div>
      </div>
    </div>
  </topo-modal>
}

<topo-confirm
  [isActive]="showConfirmClose"
  (respond)="onConfirmClose($event)"
  title="{{ 'COMMUNICATIONS.CONFIRM-CANCEL' | translate }}"
  message="{{ 'COMMUNICATIONS.CONFIRM-CANCEL-MESSAGE' | translate }}"
  noText="{{ 'COMMUNICATIONS.CONFIRM-NO' | translate }}"
  yesText="{{ 'COMMUNICATIONS.CONFIRM-YES' | translate }}"
  icon="icon-close-X"></topo-confirm>

<topo-confirm
  [isActive]="showConfirmValidation"
  (respond)="onConfirmValidation(preventSavingTemplate ? false : $event)"
  [title]="'COMMUNICATIONS.CONFIRM-VALIDATION' | translate"
  [listItems]="validationList"
  [message]="validationMessage"
  [hideNo]="!isConfirmWarning || preventSavingTemplate"
  [yesText]="(isConfirmWarning && !preventSavingTemplate ? 'COMMUNICATIONS.CONFIRM-YES' : 'COMMUNICATIONS.CONFIRM-OK') | translate"
  [noText]="'COMMUNICATIONS.CONFIRM-NO' | translate"
  icon="icon-close-X"></topo-confirm>
